import { render, staticRenderFns } from "./Tailor.vue?vue&type=template&id=c2229fdc&scoped=true&"
import script from "./Tailor.vue?vue&type=script&lang=js&"
export * from "./Tailor.vue?vue&type=script&lang=js&"
import style0 from "./Tailor.vue?vue&type=style&index=0&id=c2229fdc&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2229fdc",
  null
  
)

export default component.exports